module.exports = "<div class=\"wrapper\">\n  <div class=\"sidebar\" data-color=\"danger\" data-background-color=\"white\" data-image=\"../assets/img/sidebar-1.jpg\">\n    <app-sidebar></app-sidebar>\n    <div class=\"sidebar-background\" style=\"background-image: url(../assets/img/sidebar-4.jpg)\"></div>\n  </div>\n  <div class=\"main-panel\">\n    <app-navbar></app-navbar>\n    <router-outlet></router-outlet>\n    <div *ngIf=\"isMaps('maps')\">\n      <app-footer></app-footer>\n    </div>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/layouts/admin-layout/admin-layout.component.html
// module id = ./src/app/layouts/admin-layout/admin-layout.component.html
// module chunks = main